import { DataTypes, DomeComponent, DomeManipulator, DomeRouter, React } from "@lexriver/dome";
import { Settings } from "../../Settings";
import cssApp from '../App.m.scss';
import { IBasket } from "../Basket/IBasket";
import { Ecom } from "../Ecom/Ecom";
import { GlobalBasket } from "../GlobalBasket";
import { GlobalUser } from "../GlobalUser";
import { UrlGenerator } from "../UrlGenerator";
import { EnumPaymentType, getRussianTextForEnumPaymentType, isValidEnumPaymentType } from "../enums/EnumPaymentType";
import { getMaxProductQuantity } from "../json-data-types/JsonBasketRow";
import { getTotalAmountToPayByJsonBasketStats } from "../json-data-types/JsonBasketStats";
import { JsonShippingAddress, isValidJsonShippingAddress } from "../json-data-types/JsonShippingAddress";
import { RequestMaker } from "../server-queries/RequestMaker";
import { ServerCoupons } from "../server-queries/ServerCoupons";
import { ServerSettings } from "../server-queries/ServerSettings";
import { Link } from "./Link";
import { LoadingSpinnerForButton } from "./LoadingSpinnerForButton";
import { LoadingSpinnerForPage } from "./LoadingSpinnerForPage";
import css from './NewOrder.m.scss';
import { AutocompleteAddress } from "./form/AutocompleteAddress";
import { Checkbox } from "./form/Checkbox";
import { ErrorForForm } from "./form/ErrorForForm";
import { Form } from "./form/Form";
import { Input } from "./form/Input";
import { SelectRadio } from "./form/SelectRadio";
import { TextArea } from "./form/TextArea";

const filename = 'NewOrder.tsx'

interface Attrs{
    //shippingAddress?:JsonShippingAddress
}

enum EnumAddressType{
    Main = 'main',
    Shipping = 'shipping'
}

export class NewOrder extends DomeComponent<Attrs>{
    protected addressTypes = [
        {value:EnumAddressType.Main, text:'Основной адрес'}, 
        {value:EnumAddressType.Shipping, text:'Указать другой'}
    ]

    // protected paymentTypes = 
    // Settings.isProduction
    // ? [
    //     // {value:EnumPaymentType.Yookassa, text:getRussianTextForEnumPaymentType(EnumPaymentType.Yookassa)},
    //     Settings.checkIfDomainIsShop()
    //         ? {value:EnumPaymentType.Prodamus, text:getRussianTextForEnumPaymentType(EnumPaymentType.Prodamus)}
    //         : {value:EnumPaymentType.Yookassa, text:getRussianTextForEnumPaymentType(EnumPaymentType.Yookassa)}
    //     ,
    //     {value:EnumPaymentType.Invoice, text:getRussianTextForEnumPaymentType(EnumPaymentType.Invoice)},
    // ]
    // : [
    //     // {value:EnumPaymentType.Yookassa, text:getRussianTextForEnumPaymentType(EnumPaymentType.Yookassa)},
    //     {value:EnumPaymentType.Prodamus, text:getRussianTextForEnumPaymentType(EnumPaymentType.Prodamus)},
    //     {value:EnumPaymentType.Yookassa, text:getRussianTextForEnumPaymentType(EnumPaymentType.Yookassa)},
    //     {value:EnumPaymentType.Invoice, text:getRussianTextForEnumPaymentType(EnumPaymentType.Invoice)},
    // ]

    protected paymentTypes = 
        Settings.checkIfDomainIsShop() 
        ? [
            {value:EnumPaymentType.Prodamus, text:getRussianTextForEnumPaymentType(EnumPaymentType.Prodamus)},
            {value:EnumPaymentType.Invoice, text:getRussianTextForEnumPaymentType(EnumPaymentType.Invoice)}
        ]
        : [
            {value:EnumPaymentType.Yookassa, text:getRussianTextForEnumPaymentType(EnumPaymentType.Yookassa)},
            {value:EnumPaymentType.YookassaSBP, text:getRussianTextForEnumPaymentType(EnumPaymentType.YookassaSBP)},
            {value:EnumPaymentType.Invoice, text:getRussianTextForEnumPaymentType(EnumPaymentType.Invoice)}
        ]


    protected readonly buttonSubmitText = 'Оформить заказ'

    protected refAddress?:AutocompleteAddress
    // protected refZip!:Input
    protected refSdek?:Input
    protected refFio!:Input
    protected refPhone!:Input
    protected refEmail?:Input
    protected refAddressType?:SelectRadio
    protected refPaymentType?:SelectRadio
    protected refSubmit!:HTMLButtonElement
    protected refCheckboxPolicy!:Checkbox
    protected refComment!:TextArea

    protected showErrorWrongQuantity:boolean = false

    protected async disableFormAsync(){
        await DomeManipulator.removeAllChildrenAsync(this.refSubmit)
        this.refSubmit.appendChild(<LoadingSpinnerForButton />)
        this.refSubmit.disabled = true

        this.refAddress?.disable()
        // this.refZip.disable()
        this.refSdek?.disable()
        this.refFio.disable()
        this.refPhone.disable()
        this.refEmail?.disable()
        
        this.refCheckboxPolicy.disable()
        this.refComment.disable()

        this.refAddressType?.disable()
        this.refPaymentType?.disable()
    }

    protected async enableFormAsync(){
        this.refSubmit.disabled = false
        await DomeManipulator.removeAllChildrenAsync(this.refSubmit)
        this.refSubmit.textContent = this.buttonSubmitText

        this.refAddress?.enable()
        // this.refZip.enable()
        this.refSdek?.enable()
        this.refFio.enable()
        this.refPhone.enable()
        this.refEmail?.enable()
        this.refCheckboxPolicy.enable()
        this.refComment.enable()

        this.refAddressType?.enable()

        this.refPaymentType?.enable()
    }

    async checkifGiftCertificatesOnlyBasketAsync(){
        const basket:IBasket = await GlobalBasket.getCurrentBasketAsync()
        const basketStats = await basket.getStatsAsync({getJsonOrderItems:true})
        return basketStats.totalQuantity === basketStats.giftCertificatesQuantity
    }


    async checkIfShowPaymentTypeAsync(){
        const canSeeWholesalePrices = await GlobalUser.checkIfCanSeeWholesalePricesAsync()
        const showPaymentType = !canSeeWholesalePrices
        const basket:IBasket = await GlobalBasket.getCurrentBasketAsync()
        const basketStats = await basket.getStatsAsync({getJsonOrderItems:false})
        const totalAmountToPay = getTotalAmountToPayByJsonBasketStats({stats: basketStats, useWholesaleSum:canSeeWholesalePrices})
        return showPaymentType && totalAmountToPay>0
    }


    render(){
        return <div><LoadingSpinnerForPage /></div>
    }

    async afterRender(){
        GlobalBasket.onBasketUpdateEvent.subscribe(async () => {
            if(DomeManipulator.isInDom(this.rootElement) == false) return {unsubscribe:true}
            this.showErrorWrongQuantity = false
            this.scheduleUpdate()
            
        })

        GlobalBasket.onBasketCouponChangeEvent.subscribe(() => {
            if(DomeManipulator.isInDom(this.rootElement) == false) return {unsubscribe:true}
            this.scheduleUpdate()

        })

        this.scheduleUpdate()
    }

    protected scrollToBasketStats(){
        // this.rootElement.scrollIntoView({block:'start', behavior:'smooth'})
        const y = (this.rootElement as HTMLDivElement).offsetTop - 800
        window.scrollTo({behavior:'smooth', top: y})
    }



    async updateAsync(){
        console.log(filename ,'updateAsync()')
        const isLoggedIn = await GlobalUser.checkIfLoggedInAsync()
        // const loggedInUser = GlobalUser.loggedInUserO.get()
        // const canSeeWholesalePrices = isLoggedIn && loggedInUser && [EnumUserType.Administrator, EnumUserType.SP, EnumUserType.WholesaleUser].includes(loggedInUser.userType as EnumUserType) || false
        // const showPaymentType = !canSeeWholesalePrices

        // const basket = await GlobalBasket.getCurrentBasketAsync()
        // const basketStats = await basket.getStatsAsync()

        // const totalAmountToPay = getTotalAmountToPayByJsonBasketStats({stats: basketStats, useWholesaleSum:canSeeWholesalePrices})
        const showPaymentType = await this.checkIfShowPaymentTypeAsync()

        const isGiftCertificatesOnlyOrder = await this.checkifGiftCertificatesOnlyBasketAsync()

        // console.log('NewOrder.tsx updateAsync', 'showPaymentType=', showPaymentType, 'isLoggedIn=', isLoggedIn)

        await DomeManipulator.replaceAllChildrenAsync(this.rootElement,
        
            <Form header={isGiftCertificatesOnlyOrder ? "Личные данные" : "Куда доставить заказ?"} maxWidth="800px">
                {isLoggedIn && !isGiftCertificatesOnlyOrder &&
                <div>
                    <SelectRadio  
                        name='type' 
                        legend='Какой адрес доставки использовать' 
                        values={this.addressTypes}   
                        onChange={(newValue:string) => this.onAddressTypeChange(newValue) }
                        ref = {ref => this.refAddressType = ref}
                    />
                </div>
                }

{!isGiftCertificatesOnlyOrder && 
                <div>
                    <label>Адрес доставки: страна, город, адрес</label>
                    <AutocompleteAddress ref={ref => this.refAddress = ref} sessionStorageKey='newOrder.address' />
                </div>
    }
    {!isGiftCertificatesOnlyOrder && 
                <div>
                    <label>Адрес пункта выдачи СДЭК</label>
                    <Input ref={ref => this.refSdek = ref} sessionStorageKey="newOrder.sdek" />
                </div>
    }
                <div>
                    <label>ФИО</label>
                    <Input ref={ref => this.refFio = ref} sessionStorageKey='newOrder.fio' />
                </div>
                <div>
                    <label>Телефон</label>
                    <Input ref={ref => this.refPhone = ref} sessionStorageKey='newOrder.phone' />
                </div>
                {!isLoggedIn &&
                <div>
                    <label>Email</label>
                    <Input ref={ref => this.refEmail = ref} sessionStorageKey='newOrder.email' />
                </div>
                }
                <div>
                    <label>Комментарий (не обязательно)</label>
                    <TextArea sessionStorageKey='newOrder.comment' ref={ref => this.refComment = ref} />
                </div>


                {showPaymentType && <>
                    <div class={css.subHeaderContainer}>
                        <h2>Выберите способ оплаты</h2>
                    </div>

                    <div>
                        <SelectRadio
                            name='payment-type'
                            legend='Способ оплаты'
                            values={this.paymentTypes}
                            onChange={(newValue: string) => this.onPaymentTypeChange(newValue)}
                            ref={ref => this.refPaymentType = ref}
                        />
                    </div>
                </>}



                <div>
                    <Checkbox ref={ref => this.refCheckboxPolicy = ref}>
                        Я согласен с&nbsp;<Link url={Settings.addPrefixForUrl(await ServerSettings.getOnlyValueAsync('url-policy'))}>условиями обработки персональных данных</Link>
                    </Checkbox>
                </div>

                {this.showErrorWrongQuantity && 
                    <ErrorForForm>Не все товары есть в наличии, пожалуйста проверьте количество каждого товара. Товары с избыточным количеством выделены красным цветом.</ErrorForForm>
                }

                <div>
                    <button ref={ref => this.refSubmit = ref} onClick={async (e) => await this.onSubmitAsync({event:e, isGiftCertificatesOnlyOrder}) } class={cssApp.submitButton}>{this.buttonSubmitText}</button>
                </div>


            </Form>
        )

        if(!isLoggedIn){
            this.showShippingAddress()
            return
        }

        try {
            this.shippingAddressOnServer = await RequestMaker.sendWebsocketRouteRequestAsync('/shipping-address-get', this)
            //console.log('## shippingAddress=', shippingAddress)

            if(this.shippingAddressOnServer && isValidJsonShippingAddress(this.shippingAddressOnServer)){
                this.showShippingAddress()

            } else {
                //console.error('unable to get shipping address', shippingAddress)
                throw new Error('unable to get shipping-address') // same error message as response from server
            }

        } catch(x) {
            if(x == 'unable to get shipping-address'){ // response from server
                // no shipping address
                this.showMainAddress()

            } else {
                console.error('error while getting shipping address', x)
            }
        }

    }


    protected async onSubmitAsync(p:{event:Event, isGiftCertificatesOnlyOrder:boolean}){
        console.log(filename, 'onSubmitAsync')
        await this.disableFormAsync()
        p.event.preventDefault()    
        let isValid = true


        //#region policy
        const policy = this.refCheckboxPolicy.getValue()
        if(!policy){
            await this.refCheckboxPolicy.showErrorAsync('Пожалуйста, прочитайте и согласитесь с условиями обработки персональных данных')
            isValid = false
        }
        //#endregion



        //#region payment-type
        let paymentType = EnumPaymentType.Invoice
        if(await this.checkIfShowPaymentTypeAsync() && this.refPaymentType){ // check only if refPaymentType is visible, so for exact users only
            let paymentTypeString = this.refPaymentType.getSelectedValue()
            if(!paymentTypeString){
                await this.refPaymentType?.showErrorAsync(<>Пожалуйста, выберите тип оплаты</>)
                isValid = false

            } else {
                if(!isValidEnumPaymentType(paymentTypeString)){
                    console.error('invalid payment type', this.refPaymentType.getSelectedValue())
                    //TODO: report to server? impossible?
                } else {
                    paymentType = paymentTypeString as EnumPaymentType
                }
            }
        }
        //#endregion


        //#region phone
        const phone = this.refPhone.getValue()
        if(!phone){
            await this.refPhone.showErrorAsync(<>Пожалуйста, введите свой номер телефона</>)
            isValid = false
        }
        //#endregion phone

        //#region email
        const email = this.refEmail ? this.refEmail.getValue() : ''
        if(await GlobalUser.checkIfLoggedInAsync() === false){
            if(!email){
                if(this.refEmail){
                    await this.refEmail.showErrorAsync(<>Пожалуйста, введите свой email адрес</>)
                    isValid = false
                }
            }
        }
        if(email){
            if(!Settings.validateEmail(email)){
                await this.refEmail?.showErrorAsync(<>Пожалуйста, введите корректно свой email адрес</>)
                isValid = false
            }
        }

        //#endregion

        //#region fio
        const fio = this.refFio.getValue()
        if(!fio){
            await this.refFio.showErrorAsync(<>Пожалуйста, введите Ваше имя</>)
            isValid = false
        }
        //#endregion fio

        //#region zip
        // const zipCode = this.refZip.getValue()
        // if(!zipCode){
        //     await this.refZip.showErrorAsync(<>Пожалуйста, введите почтовый индекс</>)
        //     isValid = false
        // }
        //#endregion zip

        //#region sdek
        const sdek = this.refSdek?.getValue()
        //#endregion

        //#region address
        const address = this.refAddress?.getValue()
        if(!address && !p.isGiftCertificatesOnlyOrder){
            await this.refAddress?.showErrorAsync(<>Пожалуйста, введите адрес доставки</>)
            isValid = false
        }
        //#endregion address

        const comment = this.refComment.getValue()

        if(!isValid){
            // console.log('NewOrder.tsx form is not valid')
            await this.enableFormAsync()
            return
        }

        // await this.disableFormAsync()
        
        try {
            const basket:IBasket = await GlobalBasket.getCurrentBasketAsync()
            const rows = await basket.getListOfRowsAsync()

            //#region check if quantity is ok
            for(let row of rows){
                const maxQuantity = getMaxProductQuantity({product: row.product, chosenAttributes: row.productChosenAttributes})
                if(row.quantity > maxQuantity){
                    this.showErrorWrongQuantity = true
                    this.scheduleUpdate()
                    return
                }
            }
            //#endregion

            const canSeeWholesalePrices = await GlobalUser.checkIfCanSeeWholesalePricesAsync()
            const codes = basket.getListOfCouponCodes()

            let codesDeleted:string[] = []
            for(const code of codes){
                try {
                    const coupon = await ServerCoupons.getAsync(code, email, phone)
                    console.log(filename, 'coupon=', coupon)
                } catch(error){
                    console.error(error)
                    codesDeleted.push(code)
                    await basket.removeCouponAsync(code)
                }
            }
            if(codesDeleted.length>0){
                this.scrollToBasketStats()
                if(codesDeleted.length === 1){
                    alert(`Промокод ${codesDeleted[0]} более не действителен и был удален!`)
                } else {
                    alert(`Промокоды ${codesDeleted.join(', ')} более не действительны и были удалены!`)
                }
                return
            }

            //console.log('ready to submit', {isRetail:!GlobalUser.checkIfLoggedIn(), comment, address, zipCode, fio, phone, policy, products, email})
            const response = await RequestMaker.sendWebsocketJsonRequestAsync({
                query:'order-new', 
                params: {
                    isRetail:!(await GlobalUser.checkIfCanSeeWholesalePricesAsync()),
                    couponCodes: codes,
                    comment, address, fio, phone, policy, products: rows, email, paymentType, sdek,
                    host: window.location.host
                } 
            }, this)
            //console.log('order-new response=', response)

            
            const newOrderId = Number(response)

            await Ecom.newOrderAsync(newOrderId, rows, codes)

            if([EnumPaymentType.Yookassa, EnumPaymentType.Prodamus, EnumPaymentType.YookassaSBP].includes(paymentType)){
                // console.log('newOrderId=', newOrderId)

                if(DataTypes.isNumber(newOrderId) && newOrderId>0){
                    // await basket.clearAsync()
                    DomeRouter.navigate(UrlGenerator.payForOrder(newOrderId))
                } else throw new Error('bad newOrderId')
                //window.location.href = response.paymentUrl
            } else {
                await basket.clearAsync()
                //console.log('response=', response) // ok
                DomeRouter.navigate(UrlGenerator.pageNewOrderSuccessful)
            }

        } catch(error){
            if(error === 'wrong email'){
                console.error('That is the wrong email!') //TODO: show error
            }
            if(error === 'wrong phone'){
                console.error('That is the wrong phone!') //TODO: show error
            }
            console.error(error)
            alert('Ошибка при отправке заказа')
        }


        await this.enableFormAsync()

    }

    protected showShippingAddress(){
        if(!this.refAddress || !this.refFio || !this.refPhone) throw new Error('not all refs')

        const shippingAddress = this.shippingAddressOnServer
        //if(!shippingAddress) throw new Error('no shippingAddressOnServer')
        //if(!shippingAddress) return

        if(this.refAddressType){
            this.refAddressType.selectByValue(EnumAddressType.Shipping)
        }

        if(shippingAddress){
            this.refAddress.setValue(this.getFullAddress(shippingAddress.country, shippingAddress.city, shippingAddress.address))
            this.refFio.setValue(this.getFio(shippingAddress.firstName, shippingAddress.middleName, shippingAddress.lastName))
            this.refPhone.setValue(shippingAddress.phone)
            // this.refZip.setValue(shippingAddress.zipCode)
        }
        
        this.refAddress.enable()
        this.refFio.enable()
        this.refPhone.enable()
        // this.refZip.enable()
    } 

    protected getFullAddress(country:string|undefined, city:string|undefined, address:string|undefined){
        return ''+
        (country?country+', ':'')+
        (country?city+', ':'')+
        (address?address:'')
    }

    protected getFio(firstName:string|undefined, middleName:string|undefined, lastName:string|undefined){
        return ''+
        (lastName?lastName+' ':'')+
        (firstName?firstName+' ':'')+
        (middleName?middleName:'')
    }

    protected showMainAddress(){
        if(!this.refAddressType || !this.refAddress || !this.refFio || !this.refPhone) throw new Error('not all refs')

        const user = GlobalUser.loggedInUserO.get()
        this.refAddressType.selectByValue(EnumAddressType.Main)
        this.refAddress.setValue(this.getFullAddress(user?.country, user?.city, user?.address))
        this.refAddress.disable()
        this.refFio.setValue(this.getFio(user?.firstName, user?.middleName, user?.lastName))
        this.refFio.disable()
        this.refPhone.setValue(user?.phone)
        this.refPhone.disable()
        // this.refZip.setValue(user?.zipCode)
        // this.refZip.disable()

    }

    protected shippingAddressOnServer:JsonShippingAddress|undefined




    protected onAddressTypeChange(addressTypeValue:string){
        // disable/enable rest fields
        if(addressTypeValue == EnumAddressType.Main){
            this.showMainAddress()

        } else if(addressTypeValue == EnumAddressType.Shipping){
            this.showShippingAddress()

        } else throw new Error()
        
    }

    protected onPaymentTypeChange(paymentTypeValue:string){
        // nothing here
    }

    // protected async onSelectSuggestionAsync(text:string, suggestion:any){
    //     //console.log('text=', text, 'suggestion = ', suggestion)
    //     if(!this.refZip) return
    //     this.refZip.setValue(suggestion.data.postal_code)
    //     await this.refZip.hideErrorAsync()
    // }


}